import { UserPreferences } from "../ui";

export enum UserView {
  BUYER = 'buyer',
  SUPPLIER = 'supplier',
}

export interface SessionStore {
  userId: number;
  accountId: number;
  accountName?: string;
  isAdministrator: boolean;
  isManager: boolean;
  sessionId: number;
  name: string;
  email?: string;
  accessToken?: string;
  profiles?: string[];
  role?: string[];
  preferences?: UserPreferences;
  currentView?: UserView | null;
}